import React, { useEffect } from "react";
import "../styles/Header.css";
import IconDatePicker from "./IconDatePicker";
import dayjs from 'dayjs';

const Header = ({date, setDate}) => {


    useEffect(() => {
        const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
        };
        
        document.getElementById("date").innerHTML = date.format('LL').toString();
    }, [date])

    return (
        <>
            <div className="navbar">
                <div className="date-container">
                    <p id="date" className="big-shoulders-med"></p>
                    <IconDatePicker date={date} setDate={setDate} />
                </div>
                
                <a className="big-shoulders-lrg select-none header" href="#">FLiX DEGREES</a>
                <div className="log-in-container">
                </div>
            </div>
        </>
    );
};

export default Header;
